import { createStore } from "vuex";
import { request } from "@/plugins/axios";

export const INIT_AUTH = "INIT_AUTH"; //初始化接口认证的信息
export const FETCH_LOADING = "FETCH_LOADING";
export const CLEAR_FETCH_LIST = "CLEAR_FETCH_LIST";
export const INIT_THEME = "INIT_THEME";
export const INIT_WX_INFO = "INIT_WX_INFO";
export const SET_SHOW_LOGIN_MODAL = "SET_SHOW_LOGIN_MODAL";
import watchSessionPlugin from "./watchSessionPlugin";

// 默认主题
export default createStore({
  state: {
    fetchLoading: false,
    fetchList: [], // 请求队列
    token: "",
    authorization: "Basic ZmFfYXBwOmZhX2FwcF9zZWNyZXQ=",
    tenantId: "", // 租户ID
    outId: "", // 用户的uuid 分享出去用的，跟userId不一样
    wxInfo: null,
    showLoginModal: false, // 分享出去的页面是否显示登陆弹窗
    sensitiveList: [], //敏感词列表
  },
  mutations: {
    [INIT_AUTH](state, payload) {
      if (payload.token) {
        state.token = payload.token;
      }
      if (payload.authorization) {
        state.authorization = payload.authorization;
      }
      if (payload.tenantId) {
        state.tenantId = payload.tenantId;
      }
      if (payload.outId) {
        state.outId = payload.outId;
      }
    },
    [FETCH_LOADING](state, payload) {
      state.fetchLoading = payload.fetchLoading;
    },
    [CLEAR_FETCH_LIST](state) {
      state.fetchList.length = 0;
    },
    [INIT_THEME](state, payload) {
      if (payload.theme) {
        state.theme = payload.theme;
      }
    },
    [INIT_WX_INFO](state, payload) {
      if (payload.wxInfo) {
        state.wxInfo = payload.wxInfo;
      }
    },
    [SET_SHOW_LOGIN_MODAL](state, payload) {
      state.showLoginModal = payload.showLoginModal;
    },
    //获取敏感词列表
    SET_SENSITIVE_LIST(state, payload) {
      state.sensitiveList = payload;
    },
  },
  actions: {
    // 获取主题色  appSource 1理财师，2出借人
    async getTheme(context, { appSource, tenantId }) {
      try {
        const res = await request({
          method: "post",
          url: "/houyu-information/decoration/h5/theme",
          data: {
            appSource,
            tenantId,
          },
          fetchLoading: false,
        });
        const { success, msg, data } = res;
        if (!success) {
          return Promise.reject(new Error(msg));
        }
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    // 微页面 获取主题色  appSource 1理财师，2出借人
    async getMicroTheme(context, payload) {
      try {
        const res = await request({
          method: "post",
          url: "/houyu-information/decoration/h5/tinyPage/theme",
          data: payload,
          fetchLoading: false,
        });
        const { success, msg, data } = res;
        if (!success) {
          return Promise.reject(new Error(msg));
        }
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    //获取敏感词列表
    async getListTabooAction({ commit }) {
      try {
        const res = await request({
          method: "get",
          url: "/houyu-information/sensitive/querySensitive",
          fetchLoading: false,
        });
        const { success, msg, data } = res;
        if (!success) {
          return Promise.reject(new Error(msg));
        }
        const sensitiveEntity = data.sensitiveEntity || {};
        const content = sensitiveEntity.content || "";
        const sensitiveList = content.split("，");
        commit("SET_SENSITIVE_LIST", sensitiveList);
      } catch (error) {
        console.log(error);
      }
    },
  },
  modules: {},
  plugins: [watchSessionPlugin],
});
